import { Box, Divider, Typography } from '@mui/material';
import useAppTheme from 'hooks/useAppTheme';
import { HeaderCard } from './HeaderCard';
import { useAppSelector } from 'store/hook';
import {
  aggregateAssetWiseData,
  formatNumberToShortScale,
} from '../utils/dataFormatters';
import { useMemo } from 'react';
import { truncateTo2dp } from 'utils/helpers/general';
import { useTranslation } from 'react-i18next';
import { CLIENT_THEME, clientThemePalette } from 'utils/clientTheme';

export const MaintenanceCostKpi = () => {
  const { t } = useTranslation();
  const { enableDarkTheme } = useAppTheme();
  const palette = enableDarkTheme
    ? clientThemePalette[CLIENT_THEME].dark
    : clientThemePalette[CLIENT_THEME].light;

  const squaresDashboardAssetsData = useAppSelector(
    (state) => state.squaresDashboardReducer.assetDashboard.assets
  );

  const savingsData = useAppSelector(
    (state) => state.squaresDashboardReducer.savings
  );

  const aggregatedAssetData = useMemo(() => {
    const temp = aggregateAssetWiseData(squaresDashboardAssetsData);
    return temp;
  }, [squaresDashboardAssetsData]);

  return (
    <Box
      sx={{
        backgroundColor: enableDarkTheme
          ? palette.toolBarBackground
          : palette.toolBarBackground,
        borderRadius: '5px',
        border: enableDarkTheme ? '1px solid #2F445D' : '1px solid #BDBDBD',
      }}
      p={1}
      display={'flex'}
      flexDirection={'column'}
      gap={1}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Typography
          sx={{
            fontSize: '14px',
            color: palette.textPrimary,
            fontWeight: 'bolder',
          }}
        >
          {t('maintenance_cost')}
        </Typography>
      </Box>
      <Box
        display={'flex'}
        flexDirection={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
        gap={2}
      >
        <HeaderCard
          title={t('total_cost')}
          value={
            aggregatedAssetData.total_cost
              ? `$${formatNumberToShortScale(aggregatedAssetData.total_cost)}`
              : `0`
          }
        />

        <Divider
          orientation="horizontal"
          sx={{
            width: '2px',
            background: enableDarkTheme ? '#2F445D' : '#9E9E9E',
            height: '20px',
          }}
        />
        <HeaderCard
          title={t('per_ton')}
          value={
            aggregatedAssetData.totalTonnage
              ? `$${truncateTo2dp(
                  aggregatedAssetData.total_cost /
                    Number(aggregatedAssetData.totalTonnage)
                )}`
              : `0`
          }
        />

        <Divider
          orientation="horizontal"
          sx={{
            width: '2px',
            background: enableDarkTheme ? '#2F445D' : '#9E9E9E',
            height: '20px',
          }}
        />
        <HeaderCard
          title={t('per_mile')}
          value={
            aggregatedAssetData.totalMiles
              ? `$${truncateTo2dp(
                  aggregatedAssetData.total_cost /
                    Number(aggregatedAssetData.totalMiles)
                )}`
              : `0`
          }
        />

        <Divider
          orientation="horizontal"
          sx={{
            width: '2px',
            background: enableDarkTheme ? '#2F445D' : '#9E9E9E',
            height: '20px',
          }}
        />

        <HeaderCard
          title={t('per_engine_hr')}
          value={
            aggregatedAssetData.totalEngineHours
              ? `$${truncateTo2dp(
                  aggregatedAssetData.total_cost /
                    Number(aggregatedAssetData.totalEngineHours)
                )}`
              : `0`
          }
        />
      </Box>
      <Divider
        orientation="vertical"
        flexItem
        sx={{
          height: '2px',
          background: enableDarkTheme ? '#2F445D' : '#9E9E9E',
        }}
      />
      <Box
        display={'flex'}
        flexDirection={'row'}
        alignItems={'center'}
        justifyContent={'space-between'}
        gap={2}
      >
        <HeaderCard
          title={t('potential_cost_savings')}
          value={
            savingsData?.costSaved
              ? `$${truncateTo2dp(savingsData?.costSaved)}`
              : `0`
          }
        />
      </Box>
    </Box>
  );
};
